<script setup lang="ts">
defineProps<{ isChunkError: boolean }>()

function reload() {
  window.location.reload()
}
</script>

<template>
  <div
    class="fixed top-0 inset-x-0 z-50 flex items-center justify-center gap-4 px-4 py-2 bg-amber-200 border-b border-amber-500 text-amber-800 text-sm"
  >
    <span v-if="isChunkError">This page needs to be reloaded to continue.</span>
    <span v-else>A new version is available.</span>
    <button
      class="cursor-pointer rounded border border-amber-500 bg-amber-400 px-3 py-1 text-xs font-medium hover:bg-amber-100 transition-colors"
      @click="reload"
    >
      Reload
    </button>
  </div>
</template>
